import axios from 'axios';

type Props = {
  type?: 'pdf';
  filePath?: any;
};

const downloadFile = ({ type, filePath }: Props) => {
  let fileName = '';

  const filePathSplit = filePath.split('/');

  fileName = filePathSplit[filePathSplit.length - 1].split('.')[0];

  axios({
    url: filePath,
    method: 'GET',
    responseType: 'blob',
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      console.error('err: ', err);
    });
};

export default downloadFile;
